// getters
export const GETTERS_EMPLOYEE_LIST = "GETTERS_EMPLOYEE_LIST";
export const GETTERS_EMPLOYEE_DETAILS = "GETTERS_EMPLOYEE_DETAILS";
export const GETTERS_EMPLOYEE_FILE_HISTORY = "GETTERS_EMPLOYEE_FILE_HISTORY";

// actions
export const ACTION_GET_EMPLOYEE_LIST = "ACTION_GET_EMPLOYEE_LIST";
export const ACTION_GET_EMPLOYEE_DETAILS = "ACTION_GET_EMPLOYEE_DETAILS";
export const ACTION_GET_EMPLOYEE_FILE_HISTORY = "ACTION_GET_EMPLOYEE_FILE_HISTORY";
export const ACTION_ADD_TEST_EMPLOYEE = "ACTION_ADD_TEST_EMPLOYEE";
export const ACTION_EDIT_TEST_EMPLOYEE = "ACTION_EDIT_TEST_EMPLOYEE";
export const ACTION_TERMINATE_EMPLOYEE = "ACTION_TERMINATE_EMPLOYEE";
export const ACTION_FORCE_DELETE_EMPLOYEE = "ACTION_FORCE_DELETE_EMPLOYEE";

// mutations
export const MUTATION_SET_EMPLOYEE_LIST = "MUTATION_SET_EMPLOYEE_LIST";
export const MUTATION_SET_EMPLOYEE_DETAILS = "MUTATION_SET_EMPLOYEE_DETAILS";
export const MUTATION_SET_EMPLOYEE_FILE_HISTORY = "MUTATION_SET_EMPLOYEE_FILE_HISTORY";
export const MUTATION_TERMINATE_EMPLOYEE = "MUTATION_TERMINATE_EMPLOYEE";



// WEBPACK FOOTER //
// ./src/store/modules/employees/constants.js